import React from "react";

// Custom "circuit bolt" emblem for INELÉCTRICAS — copper + cyan on graphite.
export default function LogoMark({ size = 40, className = "" }) {
  return (
    <span
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="INELÉCTRICAS"
      >
        <defs>
          <linearGradient id="lm-hex" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#171c28" />
            <stop offset="1" stopColor="#0A0D14" />
          </linearGradient>
          <linearGradient id="lm-bolt" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#FF8A00" />
            <stop offset="1" stopColor="#E57C23" />
          </linearGradient>
        </defs>

        {/* Hex badge */}
        <path
          d="M24 2.5 L42 12.5 V35.5 L24 45.5 L6 35.5 V12.5 Z"
          fill="url(#lm-hex)"
          stroke="rgba(255,255,255,0.12)"
          strokeWidth="1"
        />
        {/* Inner hex trace (cyan) */}
        <path
          d="M24 8 L37 15.5 V30.5 L24 38 L11 30.5 V15.5 Z"
          fill="none"
          stroke="rgba(0,229,255,0.35)"
          strokeWidth="1"
          strokeDasharray="2 4"
        />

        {/* Circuit rails */}
        <path d="M11 20 H16" stroke="#00E5FF" strokeWidth="1.4" strokeLinecap="round" />
        <path d="M32 28 H37" stroke="#00E5FF" strokeWidth="1.4" strokeLinecap="round" />
        <circle cx="11" cy="20" r="1.6" fill="#00E5FF" />
        <circle cx="37" cy="28" r="1.6" fill="#00E5FF" />

        {/* Bolt formed from angular segments */}
        <path
          d="M26.5 12 L18 25 H23 L21.5 36 L31 22 H25.5 Z"
          fill="url(#lm-bolt)"
          stroke="#FFB25A"
          strokeWidth="0.6"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
